<template>
  <div class="card">
    <!-- 报价供应商详情信息 -->
    <div class="section">
      <div class="section-title">
        <base-section-title title="报价供应商信息" />
      </div>
      <div class="section-content">
        <jczh-descriptions :info="supplierInfo" :option="supplierInfoOption" />
      </div>
    </div>

    <!-- 报价单信息 -->
    <div class="section">
      <div class="section-title">
        <base-section-title title="报价单信息" />
      </div>
      <div class="section-content">
        <inquiry-offer
          v-if="isTableGreyFeatures"
          :is-wuling="true"
          :material-list="materialList"
          :is-dollar="isDollar"
          :require-tax="requireTax"
        />
        <purchase-list-supplier-offer
          v-else
          :table-data="materialList"
          :is-dollar="isDollar"
          :item-schema-list="itemSchemaList"
          :require-tax="requireTax"
        />
      </div>
    </div>

    <!--报价单签章信息-->
    <div v-if="quoteFileSignature" class="section">
      <base-section-title class="section-title" title="报价单签章文件" />
      <div class="section-content">
        <jczh-table-content
          class="m-t-10"
          :data="[quoteFileSignInfo]"
          :option="quoteAttachmentConfig"
        >
          <template v-slot:operation="{ row }">
            <div class="flex row-center">
              <upload
                upload-mode="fileId"
                :download-api="downloadQuoteFileInPurchaserApi"
                :preview-api="previewQuoteFileInPurchaserApi"
                :translate-data="{ downloadTranslate: 'fileUrl' }"
                :request-params="{
                  orderId,
                  offerId,
                  tradeId,
                  isSignFile: true,
                  fileType: 3
                }"
                :props-data="{
                  fileIdBefore: row.fileId,
                  authorization: 1,
                  disabled: true,
                  fileListHiddenControl: {
                    hiddenFileName: true,
                    hiddenDownloadBtn: false,
                    hiddenPreviewBtn: false
                  }
                }"
              />
            </div>
          </template>
        </jczh-table-content>
      </div>
    </div>

    <!--报价附件-->
    <div class="section">
      <base-section-title class="section-title" title="报价附件" />

      <div v-if="quoteAttachmentSignature" class="section-content">
        <jczh-table-content
          class="m-t-10"
          :data="attachmentSignInfo"
          :option="quoteAttachmentConfig"
        >
          <template v-slot:operation="{ row }">
            <div class="flex row-center">
              <upload
                upload-mode="fileId"
                :download-api="downloadQuoteFileInPurchaserApi"
                :preview-api="previewQuoteFileInPurchaserApi"
                :request-params="{
                  orderId,
                  offerId,
                  tradeId,
                  isSignFile: true,
                  fileType: 4
                }"
                :translate-data="{ downloadTranslate: 'fileUrl' }"
                :props-data="{
                  fileIdBefore: row.fileId,
                  authorization: 1,
                  disabled: true,
                  fileListHiddenControl: {
                    hiddenFileName: true,
                    hiddenDownloadBtn: false,
                    hiddenPreviewBtn: false
                  }
                }"
              />
            </div>
          </template>
        </jczh-table-content>
      </div>

      <!--附件不需要签章的展示-->
      <div v-else class="section-content">
        <upload
          v-if="attachmentIds.length > 0"
          v-model="attachmentIds"
          :download-api="downloadQuoteFileInPurchaserApi"
          :preview-api="previewQuoteFileInPurchaserApi"
          :translate-data="{ downloadTranslate: 'fileUrl' }"
          :request-params="{
            orderId,
            offerId,
            tradeId,
            isSignFile: false,
            fileType: 4
          }"
          upload-mode="fileId"
          :props-data="{
            disabled: true
          }"
        />
        <div v-else>暂无附件</div>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload/UploadAuthorizationFile'
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import PurchaseListSupplierOffer from '@/components/common/PurchaseListComponent/SupplierOffer/index.vue'
import InquiryOffer from '@/components/inquiry/InquiryOffer.vue'
// 接口
import {
  getInquiryOrderApi,
  getApprovalSupplierInfoApi,
  getSupplierQuoteDetailApi,
  previewQuoteFileInPurchaserApi,
  downloadQuoteFileInPurchaserApi
} from '@/api/procure/inquiry'
// 工具方法
import DateUtils from '@/utils/date'
import { isEmptyArray } from '@/utils/type-check'
import { strToThousands } from '@/utils/utils'
// 数据字典
import { inquiryRequireTaxDict } from '@/dictionary/project/inquiry'
import {
  fileWhetherSignatureDict,
  whetherSignatureDict,
  currencyTypeDict
} from '@/dictionary/project/common'

import { mapActions } from 'vuex'

export default {
  name: 'InquiryQuoteInfo',

  components: {
    BaseSectionTitle,
    Upload,
    PurchaseListSupplierOffer,
    InquiryOffer
  },

  filters: {
    dateFilter(date) {
      return DateUtils.format(date, 'yyyy.MM.dd HH:mm:ss')
    }
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },
    isByOrderId: {
      type: Boolean,
      default: true
    },
    isWuling: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const { orderId, roundId, offerId, tradeId } = this.$route.params
    return {
      // 路由参数
      orderId,
      roundId,
      offerId,
      tradeId,

      isTableGreyFeatures: false,

      // 项目信息
      requireTax: '', // 报价是否含税
      quoteFileSignature: false, // 报价单是否需要签章
      quoteAttachmentSignature: false, // 报价附件是否需要签章

      supplierInfoOption: [
        { label: '企业名称', prop: 'supplierName' },
        { label: '联系人姓名', prop: 'contactUserName' },
        { label: '联系人电话', prop: 'contactUserPhone' },
        { label: '联系人邮箱', prop: 'contactUserEmail' },
        {
          label: '报价时间',
          prop: 'signUpTime',
          filter: value => {
            return value !== ' - '
              ? DateUtils.format(value, 'yyyy.MM.dd HH:mm')
              : value
          }
        }
      ],
      supplierInfo: {}, // 报价供应商信息
      materialList: [], // 品目报价信息

      // 报价单信息
      quoteFileSignInfo: {}, // 报价单签章信息

      // 报价附件id
      attachmentIds: '',
      attachmentSignInfo: [],
      quoteAttachmentConfig: [
        {
          label: '报价附件',
          prop: '',
          filter: value => value.signatureFileName || value.fileName,
          minWidth: '200px'
        },
        {
          label: '签章状态',
          prop: 'signStatus',
          tagDict: fileWhetherSignatureDict
        },
        { label: '操作', slotName: 'operation' }
      ],

      // 字段设置
      itemSchemaList: [],

      isDollar: false
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val) {
          this.orderInfo = this.requestQuery?.orderInfo || {}
          this.requireTax =
            this.orderInfo.order?.offerRequireTax ===
            inquiryRequireTaxDict.YES.value
          this.quoteFileSignature =
            this.orderInfo.order?.quotationElectronicSignature ===
            whetherSignatureDict.NEED.value
          this.quoteAttachmentSignature =
            this.orderInfo.order?.quotationAccessoryElectronicSignature ===
            whetherSignatureDict.NEED.value
          this.isDollar =
            this.orderInfo.order?.currencyType === currencyTypeDict.DOLLAR.value

          this.itemSchemaList = val.itemSchemaList || []
          this.fetchSupplierInfo()
          this.fetchQuoteList()
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        if (this.isByOrderId && val) {
          this.getOrderInfo()
          this.fetchSupplierInfo()
          this.fetchQuoteList()
        }
      },
      immediate: true
    },

    isWuling(val) {
      this.isTableGreyFeatures = val
    }
  },

  // async created() {
  //   this.isTableGreyFeatures = await this.showGreyFeature({
  //     code: 'inquiry-table'
  //   })
  // },

  methods: {
    ...mapActions('company', ['showGreyFeature']),

    strToThousands,

    // 后端的文件鉴权接口
    previewQuoteFileInPurchaserApi,
    downloadQuoteFileInPurchaserApi,

    /**
     * 获取询比单信息
     */
    getOrderInfo() {
      return getInquiryOrderApi({ orderId: this.orderId })
        .then(res => {
          this.orderInfo = res?.data || {}
          this.isTableGreyFeatures = Boolean(res.data?.order?.isWuling)
          this.requireTax =
            this.orderInfo?.order?.offerRequireTax ===
            inquiryRequireTaxDict.YES.value

          // 获取报价单与报价附件是否需要签章
          this.quoteFileSignature =
            res?.data?.order?.quotationElectronicSignature ===
            whetherSignatureDict.NEED.value
          this.quoteAttachmentSignature =
            res?.data?.order?.quotationAccessoryElectronicSignature ===
            whetherSignatureDict.NEED.value
          this.isDollar =
            this.orderInfo.order?.currencyType === currencyTypeDict.DOLLAR.value

          this.itemSchemaList = this.orderInfo.itemSchemaList || []
        })
        .catch(err => {
          this.$message.error(err.message || '获取询比单信息')
        })
    },
    // 获取报名供应商基本信息
    fetchSupplierInfo() {
      const { orderId, tradeId } = this.$route.params
      getApprovalSupplierInfoApi({ orderId, tradeId })
        .then(res => {
          this.supplierInfo = res.data || {}
        })
        .catch(err => {
          this.$message.error(err.message || '获取供应商信息失败')
        })
    },

    // 获取品目报价表
    fetchQuoteList() {
      getSupplierQuoteDetailApi({
        orderId: this.orderId,
        roundId: this.roundId,
        offerId: this.offerId
      })
        .then(res => {
          this.materialList = res.data.detailList || []

          // 上传报价附件 及其 签章信息
          this.attachmentIds = res.data.offerFileIds || []
          this.attachmentSignInfo = this.attachmentIds
            .map(fileId => {
              return (
                res?.data?.signatureOfferDetailVos.find(
                  vos => vos.fileId === fileId
                ) || undefined
              )
            })
            .filter(value => value)

          // 获取报价文件信息
          this.quoteFileSignInfo =
            (res?.data?.signatureOfferDetailVos || []).find(value => {
              if (this.attachmentIds.includes(value.fileId)) return false
              else return true
            }) || {}

          isEmptyArray(this.materialList)
        })
        .catch(err => {
          console.error('获取品目报价表失败', err)
          this.$message.error(err.message || '获取品目报价信息失败')
        })
    }
  }
}
</script>

<style scoped></style>
